'use strict'

import store from '@/store'
import router from '@/router'

export function hasRole (group, role) {
  if (group && role) {
    const roles = store.state.userClaims.claims
    if (roles && roles[group]) {
      const hasRole = Boolean(roles[group][role])
      return hasRole
    }
    return false
  }
  return false
}

export function isNoMainMenuFromV4 () {
  const noMainMenuFromV4 = store.state.mainMenu.noMainMenuFromV4
  return noMainMenuFromV4
}

export function isObject (val) {
  return Boolean(val && typeof val === 'object' && Object.keys(val).length)
}

export function isArray (val) {
  return Boolean(val && Array.isArray(val) && val.length)
}

export function downloadCsv (filename = 'export.csv', csv) {
  if (!csv) return
  let hiddenElement = document.createElement('a')
  hiddenElement.href = window.URL.createObjectURL(new Blob([csv]))
  hiddenElement.target = '_blank'
  hiddenElement.download = filename
  hiddenElement.click()
}

export function convertToCurrencyBRL (value) {
  // https://ptax.bcb.gov.br/ptax_internet/consultarTabelaMoedas.do?method=consultaTabelaMoedas
  const val = !value ? 0 : value
  return `${val.toLocaleString('pt-br', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL'
  })}`
}

export function capitalizeFirstLetter (value) {
  if (!value) return
  const arr = value.split('')
  arr[0] = arr[0].toUpperCase()
  return arr.join('')
}

export function formatDate (date) {
  if (!date) return
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export function mapArgs (...args) {
  const params = {}
  args.forEach(element => {
    const key = Object.keys(element)
    params[key] = element[key]
  })
  return params
}

export function mapParams (obj) {
  return obj ? Object.keys(obj).map(key => ({ [key]: obj[key] })) : []
}

export function sanitizeCostCenters (costCenters = []) {
  let sanitized = []
  costCenters.forEach(element => {
    sanitized.push(element.id)
  })
  return sanitized
}

export function calcContentHeight (debug = false) {
  const elems = document.querySelectorAll('.get-height')
  const totalHeight = Array.from(elems).reduce((acc, item, arr) => {
    acc = acc + item.offsetHeight
    return acc
  }, 0)

  // refactor fixed selector
  const vTabsContainer = document.querySelector('.report-drawer .v-tabs__container')
  const vTabsContainerHeight = vTabsContainer ? vTabsContainer.offsetHeight : 0

  return window.innerHeight - totalHeight - vTabsContainerHeight
}

export function convertToCoin (value, placeholder = null, lang = 'pt-br', currency = 'BRL') {
  // coin table: https://goo.gl/uFmJj7
  const defaultConfig = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency
  }

  if (!value && placeholder) return placeholder
  if (!value) return `${Number(0).toLocaleString(lang, { ...defaultConfig })}`
  return `${value.toLocaleString(lang, { ...defaultConfig })}`
}

export function formatNumber (value, placeholder = null, lang = 'pt-br', currency = 'BRL') {
  // coin table: https://goo.gl/uFmJj7
  const defaultConfig = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    currency
  }

  if (!value && placeholder) return placeholder
  if (!value) return `${Number(0).toLocaleString(lang, { ...defaultConfig })}`
  return `${value.toLocaleString(lang, { ...defaultConfig })}`
}

export function stringToFloat (val) {
  if (!val || val === 'R$ 0,00') return 0

  let str = val.replace(/R\$\s/, '')
  if (str.length < 10) {
    str = str.replace('.', '').replace(',', '.')
  } else {
    let arr = /(.+)\.?(\d{1,2})$/.exec(str)
    str = `${arr[1].replace(/\./g, '').replace(',', '.')}${arr[2]}`
  }

  return Number(str)
}

export function floatToPercent (val, decimalPlaces = 0) {
  const v = val > 0 ? String(val.toFixed(decimalPlaces)) : '0'
  return v.replace('.', ',') + '%'
}

export function removeDuplicateItemsInArray (arr) {
  let unique = {}
  arr.forEach(i => {
    if (!unique[i]) unique[i] = true
  })
  return Object.keys(unique)
}

export function objectToArray (obj) {
  if (!obj) return
  if (Array.isArray(obj) && obj.length) return obj
  if (Array.isArray(obj) && !obj.length) return []

  return Object.keys(obj).reduce((acc, item) => {
    acc.push(obj[item])
    return acc
  }, [])
}

export function preventInsertValue (event, regexPattern = /[0-9]/) {
  let key = event.keyCode || event.which
  key = String.fromCharCode(key)
  const regex = new RegExp(regexPattern)

  if (!regex.test(key)) {
    event.returnValue = false
    if (event.preventDefault) event.preventDefault()
  }
}

export function getRideCategory (vm, category = '') {
  /* todo: ridesCategoriesList */
  const categoryTarget = objectToArray(vm.$store.state.commonConfig.categories).find(cat => {
    const taxiCategoryName = cat.taxiCategoryName ? cat.taxiCategoryName.toLowerCase() : null
    const value = cat.value ? cat.value.toLowerCase() : null
    const categoryTrim = category ? category.trim().toLowerCase() : null
    return taxiCategoryName === categoryTrim || value === categoryTrim
  })

  return categoryTarget
    ? { text: categoryTarget.text, html: categoryTarget.html }
    : { text: category, html: category }
}

export function getRideCategoryByAttr (vm, attr) {
  const { key, value } = attr || {}
  const categoryTarget = objectToArray(vm.$store.state.commonConfig.categories).find(cat => {
    return cat[key] === value
  })
  return categoryTarget || {}
}

export function convertNumberToStringNotation (
  num,
  lang = 'en-US',
  notation = 'compact',
  compactDisplay = 'short'
) {
  const n = Math.floor(num)
  return Intl.NumberFormat(lang, {
    notation,
    compactDisplay
  }).format(n)
}

export function generateRand (min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

export function consoleInfo (msg) {
  if (console && console.info) {
    console.info(msg)
  }
}

/**
 * 通用返回上一页函数
 * 先尝试通过 window.reactBack() 返回，如果不成功则使用 Vue Router 返回
 * 不需要传入 router 参数，直接使用全局 router 实例
 * @returns {Boolean} - 返回是否成功
 */
export function goBack () {
  const isSuccess = window.reactBack && window.reactBack()
  if (!isSuccess) {
    router.go(-1)
  }
  return isSuccess
}
